import { useState } from 'react';
export const useQAsyncTablePagination = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
  ];
  const [paginationOptions, setPaginationOptions] = useState({
    total: 0,
    lastPage: 0,
    perPage: 0,
  });

  const handleChangePage = (newPage, event) => {
    if (event) {
      event.preventDefault();
    }
    setPage(newPage);
  };

  const handlePageSizeChange = option => {
    setPageSize(option.value);
    setPage(1);
  };

  return {
    page,
    pageSize,
    pageSizeOptions,
    paginationOptions,
    setPaginationOptions,
    handleChangePage,
    handlePageSizeChange,
  };
};
